module.exports = __webpack_public_path__ + "img/advanced.972c71c9.svg";